module.exports = __webpack_public_path__ + "static/img/iphone.b3423b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iphone.png
// module id = i1/Y
// module chunks = 0